// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__d5hle","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1UiRY"};